import { rootModuleId } from "@app/const";
import BaseComponent from "./BaseComponent";
import Dropdown from "./Dropdown";
import ModuleInputsGroup from "./ModuleInputsGroup";

export class CoMoWizardConfig extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            inputOptions: window.apm.knowledgeBase.getInputTypes(),
            wizardConfig: window.apm.serialized.wizardConfig ?? {}
        };
    }

    setConfig(key, value) {
        const { wizardConfig } = this.state;
        wizardConfig[key] = value;
        wizardConfig.lastLocalChange = window.apm.timestamp;
        this.setState({ wizardConfig })
        window.apm.setSerializedChanged();
    }

    getConfig(key) {
        return this.state.wizardConfig[key];
    }

    getPromptOptions() {
        const prompts = window.apm.knowledgeBase.getPrompts();
        return prompts.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }
    getModuleInputs() {
        const localVariables = window.apm.serialized.components.modules.find(m => m.id === rootModuleId).localVariables;
        let moduleInputs = [];
        localVariables.forEach(lv => {
            if (lv.props.config.moduleInput) {
                moduleInputs.push(lv);
            }
        })
        return moduleInputs;
    }

    getDropdownSelection(type, options) {
        return window.apm.knowledgeBase.getIndexFromValue(this.getConfig(type), options);
    }

    render() {
        const expectedIntentOptions = window.apm.knowledgeBase.getIntents();
        const promptOptions = this.getPromptOptions();
        const moduleInputs = this.getModuleInputs();
        const { inputOptions } = this.state;

        return (
            <div className="col-md-12">
                <div className="row" >
                    <div className="col-md-6">
                        <Dropdown
                            label={window.l.settings.initialPrompt}
                            context={this}
                            optionName={window.l.settings.select_prompt}
                            options={promptOptions}
                            valKey={"initialPrompt"}
                            selection={this.getDropdownSelection("initialPrompt", promptOptions)}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={window.l.settings.invalidPrompt}
                            context={this}
                            optionName={window.l.settings.select_prompt}
                            options={promptOptions}
                            valKey={"invalidPrompt"}
                            selection={this.getDropdownSelection("invalidPrompt", promptOptions)}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={window.l.settings.rePrompt}
                            context={this}
                            optionName={window.l.settings.select_prompt}
                            options={promptOptions}
                            valKey={"rePrompt"}
                            selection={this.getDropdownSelection("rePrompt", promptOptions)}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={window.l.settings.confirmPrompt}
                            context={this}
                            optionName={window.l.settings.select_prompt}
                            options={promptOptions}
                            valKey={"confirmPrompt"}
                            selection={this.getDropdownSelection("confirmPrompt", promptOptions)}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={"Expected Intent"}
                            context={this}
                            optionName={"Select Expected Intent"}
                            options={expectedIntentOptions}
                            valKey={"expectedIntent"}
                            selection={this.getDropdownSelection("expectedIntent", expectedIntentOptions)}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={"Input Type"}
                            context={this}
                            optionName={"Select Input Type"}
                            options={inputOptions}
                            valKey={"inputType"}
                            selection={this.getDropdownSelection("inputType", inputOptions)}
                            removable={true} />
                    </div>
                </div>
                <hr />
                <div className={"row"}>
                    <div className="col-md-12" style={{marginTop:"10px",fontSize:"14px"}}>
                        <label>Module Inputs</label>
                    </div>
                        <div className={"col-md-12"}>
                        {(() => {
                            const moduleNodeGroup = [];
                            moduleNodeGroup.push(
                                <ModuleInputsGroup 
                                    context={this}
                                    moduleInputs={moduleInputs}
                                    key="moduleInputs"
                                />);
                            return moduleNodeGroup;
                        })()}
                    </div>
                </div>
            </div>
        );
    }
}